import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import * as mutations from './mutations';
import * as actions from './actions';

Vue.use(Vuex);

let plugins = [];
const debug = process.env.NODE_ENV !== 'production';
if (debug) {
    plugins.push(createLogger());
}

import { define } from 'utils/factory';

import upload from 'store/modules/upload';
import basic from 'store/modules/basic';
import template from 'store/modules/template';
import tags from 'store/modules/tags';
import elementTag from 'store/modules/elementTag';
import userMaterial from 'store/modules/userMaterial';
import tagedElement from 'store/modules/tagedElement';
import group from 'store/modules/group';
import groupList from 'store/modules/groupList';
import analysis from 'store/modules/analysis';
import material from 'store/modules/material';
import element from 'store/modules/element';
import account from 'store/modules/account';
import customer from 'store/modules/customer';
import company from 'store/modules/company';
import video from 'store/modules/video';
import videoTemplate from 'store/modules/videoTemplate';

const store = new Vuex.Store({
    state: {
        name: '',
        keys: [],
        tpl: null,
        clipboard: null,
        task_api_response: null,
        activeKey: null,
        activeAction: null,
        currentTime: 0,
        designWidth: 0,
        designHeight: 0,
        history_wind: 0,
        scaleRate: 1,
        moving: false,
        rotating: false,
        editing: false,
        actions: [],
        elements: [],
        canvas: [],
        history: [],
        ae_type: '',
        ae_tpl: {},
        resource: {},
        outputDesc: {},
        selected: {},
        slots: [],
        positionList: [], //刻度线点集合
    },
    plugins,
    mutations,
    actions,
    modules: {
        basic,
        template,
        tags,
        elementTag,
        userMaterial,
        group,
        upload,
        groupList,
        analysis,
        material,
        element,
        account,
        customer,
        company,
        video,
        videoTemplate,
        tagedElement
    },
    strict: false
});

export default store;
